// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logo {
  display: inline-flex;
  align-items: center;
  gap: 0.65rem;
  min-width: 0;
}

.logo__mark {
  flex-shrink: 0;
  display: block;
}

.logo--sm .logo__mark {
  width: 1.5rem;
  height: 1.5rem;
}

.logo--md .logo__mark {
  width: 2rem;
  height: 2rem;
}

.logo--lg .logo__mark {
  width: 2.5rem;
  height: 2.5rem;
}

.logo__text {
  font-family: var(--font-display);
  font-weight: 700;
  letter-spacing: -0.03em;
  line-height: 1;
  white-space: nowrap;
}

.logo--sm .logo__text {
  font-size: 0.95rem;
}

.logo--md .logo__text {
  font-size: clamp(1rem, 2.4vw, 1.2rem);
}

.logo--lg .logo__text {
  font-size: 1.35rem;
}

.logo__domain {
  font-weight: 600;
}

.logo--light .logo__ink {
  fill: #d6f06a;
}

.logo--light .logo__text {
  color: #ffffff;
}

.logo--light .logo__domain {
  color: rgba(255, 255, 255, 0.72);
}

.logo--dark .logo__ink {
  fill: #0f2e24;
}

.logo--dark .logo__text {
  color: #0f2e24;
}

.logo--dark .logo__domain {
  color: #5a6d64;
}
`, "",{"version":3,"sources":["webpack://./src/components/Logo.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".logo {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 0.65rem;\r\n  min-width: 0;\r\n}\r\n\r\n.logo__mark {\r\n  flex-shrink: 0;\r\n  display: block;\r\n}\r\n\r\n.logo--sm .logo__mark {\r\n  width: 1.5rem;\r\n  height: 1.5rem;\r\n}\r\n\r\n.logo--md .logo__mark {\r\n  width: 2rem;\r\n  height: 2rem;\r\n}\r\n\r\n.logo--lg .logo__mark {\r\n  width: 2.5rem;\r\n  height: 2.5rem;\r\n}\r\n\r\n.logo__text {\r\n  font-family: var(--font-display);\r\n  font-weight: 700;\r\n  letter-spacing: -0.03em;\r\n  line-height: 1;\r\n  white-space: nowrap;\r\n}\r\n\r\n.logo--sm .logo__text {\r\n  font-size: 0.95rem;\r\n}\r\n\r\n.logo--md .logo__text {\r\n  font-size: clamp(1rem, 2.4vw, 1.2rem);\r\n}\r\n\r\n.logo--lg .logo__text {\r\n  font-size: 1.35rem;\r\n}\r\n\r\n.logo__domain {\r\n  font-weight: 600;\r\n}\r\n\r\n.logo--light .logo__ink {\r\n  fill: #d6f06a;\r\n}\r\n\r\n.logo--light .logo__text {\r\n  color: #ffffff;\r\n}\r\n\r\n.logo--light .logo__domain {\r\n  color: rgba(255, 255, 255, 0.72);\r\n}\r\n\r\n.logo--dark .logo__ink {\r\n  fill: #0f2e24;\r\n}\r\n\r\n.logo--dark .logo__text {\r\n  color: #0f2e24;\r\n}\r\n\r\n.logo--dark .logo__domain {\r\n  color: #5a6d64;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
